export const ClientsNav = [
  {
    icon: "lnr-chart-bars",
    label: "PICA NGPON2 C&S Verizon",
    to: "#/pica_cs_vz",
  },
];


// WEBPACK FOOTER //
// ./src/Layout/AppNav/NavItems.js